import React from 'react';
import {DEFAULT_PRIMARY_COLOR} from '../../../data/staticValues/colors';

interface Props {
  answer: string;
  selected: boolean;
  onClick: (answer: string) => void;
}

const AnswerCircle = React.memo(({answer, selected, onClick}: Props) => {
  const primaryColor =
    typeof window !== 'undefined'
      ? localStorage.getItem('primaryColor') || DEFAULT_PRIMARY_COLOR
      : DEFAULT_PRIMARY_COLOR;
  return (
    <div onClick={() => onClick(answer)} className="AnswerCircle">
      <div className="Checkbox">
        {selected ? (
          <div className="Checked" style={{backgroundColor: primaryColor}} />
        ) : (
          <div />
        )}
      </div>
      <span>{answer}</span>
    </div>
  );
});

export default AnswerCircle;
